import { endpoints } from './endpoints'

type TypeFetchOptions = {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' // *GET
  mode?: 'cors' | 'no-cors' | 'same-origin', // no-cors, *cors, same-origin
  cache?: 'default' | 'no-cache' | 'reload' | 'force-cache' | 'only-if-cached' | 'no-store', // *default
  credentials?: 'same-origin' | 'include' | 'omit', // *same-origin
  headers?: {
    'Accept'?: 'application/json' | 'image/*',
    'Content-Type'?: 'application/json' | 'application/x-www-form-urlencoded' | 'multipart/form-data' | 'text/plain'
    [key:string]: any
  },
  redirect?: 'follow' | 'manual' | 'error', // *follow
  referrerPolicy?: 'no-referrer' | 'no-referrer-when-downgrade' | 'origin' | 'origin-when-cross-origin' | 'same-origin' | 'strict-origin' | 'strict-origin-when-cross-origin' | 'unsafe-url' // *no-referrer-when-downgrade
  body?: any // body data type must match "Content-Type" header
  next?: {
    revalidate?: number
  }
}
// Any body that you want to add to your request: this can be a Blob, an ArrayBuffer, a TypedArray, a DataView, a FormData, a URLSearchParams, string object or literal

const defaultOptions:TypeFetchOptions = {
  method: 'GET',
  mode: 'cors',
  cache: 'default',
  credentials: 'same-origin',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  redirect: 'follow',
  referrerPolicy: 'no-referrer',
  body: null
}

type TypeQuery = {
  slug?: string,
  project_id?: number,
  image_id?: number,
  promt_image_id?: number,
}


type TypeFetchApi = (urlNamespace: keyof typeof endpoints, query?: TypeQuery, options?:TypeFetchOptions) => Promise<any>

export const fetchAPI:TypeFetchApi = async (endpointNamespace, query = {}, fetchOptions) => {
  if(!endpointNamespace || !endpoints[endpointNamespace]) {
    throw new Error(`api/endpoints.ts -> No endpoint with namespace: '${endpointNamespace}'`)
  }

  const url = endpoints[endpointNamespace](query)

  const options = !fetchOptions ? defaultOptions : {...defaultOptions, ...fetchOptions }

  // const contentType = options?.method === 'POST' ? 'application/x-www-form-urlencoded' : 'application/json'
  // if(!fetchOptions.headers) options.headers['Content-Type'] = contentType
  const body = options.body ?? null

  try {
    const res:Response = await fetch(url, {...options, body })
    if (endpointNamespace.indexOf('pdf') !== -1) {
      const filePdf = res.blob()
      return filePdf
    }
    return res
  } catch (error) {
    console.log('fetchMethod catch error:', error)
    return {...error, type: 'server_error' }
  }
}
